// @ts-check
// A página do registro publica o registro aberto: o menu de comandos oferece as ações dele e a busca vazia o mostra
// entre os recentes (contrato 08-contrato-comandos-atalhos, seções 1 e 4).
import { useEffect, useRef } from 'preact/hooks';
import { getRecordLabel } from '../../lib/field-metadata.js';
import { buildRecordSubtitle } from '../../lib/search-preview.js';
import { formatDate, formatPhone } from '../../lib/format.js';
import { translateMetadataLabel } from '../../i18n/index.js';
import { activeRecordShowState, rememberRecentRecord } from './command-state.js';

export const PREVIEW_FORMATTERS = { translateLabel: translateMetadataLabel, formatPhone, formatDate };

/**
 * @param {{ objectMetadata: import('../../lib/field-metadata.js').ObjectMetadata | undefined, record: any, reload: () => void, restore?: () => Promise<void> }} input
 */
export function usePublishActiveRecord({ objectMetadata, record, reload, restore }) {
  const latest = useRef({ reload, restore });
  latest.current = { reload, restore };
  useEffect(() => {
    if (!objectMetadata || !record) return undefined;
    /** @type {import('./command-state.js').RecordShowTarget} */
    const target = { objectMetadata, record, reload: () => latest.current.reload(), restore: () => latest.current.restore?.() };
    activeRecordShowState.value = target;
    return () => {
      if (activeRecordShowState.peek() === target) activeRecordShowState.value = null;
    };
  }, [objectMetadata, record]);

  const label = objectMetadata && record ? getRecordLabel(objectMetadata, record) : '';
  useEffect(() => {
    if (!objectMetadata || !record || record.deletedAt) return;
    rememberRecentRecord({
      objectNameSingular: objectMetadata.nameSingular, recordId: record.id, label, subtitle: buildRecordSubtitle(objectMetadata, record, PREVIEW_FORMATTERS),
    });
  }, [objectMetadata?.nameSingular, record?.id, label]);
}
